module.exports = __webpack_public_path__ + "static/media/1.788f4c31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/1.jpg
// module id = 778
// module chunks = 0